import { FiltroBusquedaDTO } from '../dtos/solicitudes/filtro-busqueda.dto';

/**
 * Modelo para los datos de las ventanas modal del sistema
 */
export class VentanaModalModel {

  /** permite visualizar el modal */
  public isShowModal: boolean | any;

  /** son los datos a visualizar en el modal */
  public data: any;

  /** son los datos a visualizar en el modal clonado */
  public dataClone: any;

  /** Si el modal tiene filtro de busqueda */
  public filtro: FiltroBusquedaDTO | any;

  /** Es el clone del filtro de busqueda si aplica */
  public filtroClone: FiltroBusquedaDTO | any;

  /** Bandera que se utiliza para identificar si hay filtro busqueda aplicado */
  public hayFiltroAplicado: boolean | any;

  /** Se utiliza para mapear cualquier dato que se necesite */
  public anyData: any;

  /**
   * Es invocado cuando se cierra el modal
   */
  public closeModal(resetData: boolean = true): void {
    this.isShowModal = false;
    if (resetData)
      this.data = null;
    this.dataClone = null;
    this.anyData = null;
  }

  /**
   * Es invocado para abrir el modal
   */
  public showModal(datos: any): void {
    this.isShowModal = true;
    this.data = datos;
  }

  /**
   * Es invocado para abrir el modal
   * haciendo un clone de la data
   */
  public showModalWithClone(datos: any): void {
    this.isShowModal = true;
    this.data = datos;
    this.dataClone = JSON.parse(JSON.stringify(this.data));
  }
}
